import axios from '@lib/axios';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export interface Inputs {
  companyId: string;
  startsAt: Date;
  endsAt: Date;
}

interface HookProps {
	onSuccess?: (filepath: string) => void;
  onError?: (error: AxiosResponse) => void;
}

export const useContentReport = ({
	onSuccess,
  onError
}: HookProps) => {
  const {
		mutate: onGenerateContentReport,
		...rest
	} = useMutation({
		mutationFn: async (data: Inputs) => {
			const { data: { filename } } = await axios.post('/reports/contents', data);
      return filename;
		},
		onSuccess,
    onError
	});

	return { onGenerateContentReport, ...rest };
};
